import $ from "jquery";
import getConfig from "./config";

const config = getConfig();

class AccessibleSlick {
    static sliders = [];

    static async setupSlick() {
        this.sliders = [...document.getElementsByClassName("slick-slider")];
        if (0 < this.sliders.length) {
            await import("@accessible360/accessible-slick/slick/slick.min.css");
            await import("@accessible360/accessible-slick/slick/slick-theme.min.css");
            await import("@accessible360/accessible-slick/slick/slick");
            $(this.sliders)
                .on("init", (e, slick) =>
                    this.updateSliderSlide(
                        slick.$slides[slick.currentSlide] ?? null,
                        slick.$slider[0] ?? null,
                    ),
                )
                .on("reInit", (e, slick) =>
                    this.updateSliderSlide(
                        slick.$slides[slick.currentSlide] ?? null,
                        slick.$slider[0] ?? null,
                    ),
                )
                .on("beforeChange", (e, slick, currentSlide, nextSlide) =>
                    this.updateSliderSlide(
                        slick.$slides[nextSlide] ?? null,
                        slick.$slider[0] ?? null,
                    ),
                )
                .slick()
                .off("blur.slick", "*");
            this.updateSliders();
            window.addEventListener("load", (e) => this.updateSliders(e));
            window.addEventListener("resize", (e) => this.updateSliders(e));
        }
    }

    static setupTestimonialSliders() {
        [...document.querySelectorAll(".testimonial-slider")].forEach(
            (testimonials) => {
                const btns = {
                    prev: {
                        btn: testimonials.querySelector(
                            ".testimonial-slider__prev-btn",
                        ),
                        method: "slickPrev",
                    },
                    next: {
                        btn: testimonials.querySelector(
                            ".testimonial-slider__next-btn",
                        ),
                        method: "slickNext",
                    },
                };

                for (const {btn, method} of Object.values(btns)) {
                    if (btn) {
                        const slider_id = btn.getAttribute(
                            `data-${config.appName}-slider`,
                        );
                        const slider = slider_id
                            ? document.getElementById(slider_id)
                            : null;

                        if (slider) {
                            const $slider = $(slider);
                            btn.addEventListener("click", () => {
                                $slider.slick(method);
                            });
                        }
                    }
                }
            },
        );
    }

    static updateSliders(e = null, slide = null) {
        if (0 === this.sliders.length) {
            return;
        }

        const event_type = e?.type ?? "";

        if (slide) {
            const slider = slide.closest(".slick-slider");
            event_type === "resize" && $(slider).slick("setPosition");
            this.updateSliderSlide(slide, slider);
        } else {
            this.sliders.forEach((slider) => {
                const updateSlide = () => {
                    this.updateSliderSlide(
                        slider.querySelector(".slick-slide.slick-active"),
                        slider,
                    );
                };

                if ("resize" === event_type) {
                    $(slider)
                        .slick("setPosition")
                        .one("setPosition", updateSlide);
                } else {
                    updateSlide();
                }
            });
        }
    }

    static updateSliderSlide(slide, slider = null) {
        if (!slide) {
            return;
        }

        slider = slider || slide.closest(".slick-slider");
        const img = slide.querySelector("img");
        let imgHeight = img?.getBoundingClientRect()?.height ?? null;
        imgHeight = imgHeight ? imgHeight + "px" : null;
        slider?.style?.setProperty(
            `${config.prefix}slick-slider-current-slide-image-height`,
            imgHeight,
        );
    }
}

export default AccessibleSlick;
